<template>
    <div 
        class="p-inputgroup"
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <PrimeInputNumber 
            v-model="localValue" 
            @input="handleInput"
            mode="decimal"
            :minFractionDigits="localMinFractionDigits" 
            :maxFracionDigits="localMaxFractionDigits"
            :min="min"
            :max="max"
            :step="step"
            v-bind="context.attributes"
            :disabled="isDisabled"
            :placeholder="placeholder"
            @blur="context.blurHandler"
        />
    </div>
</template>

<script>
import PrimeInputNumber from 'primevue/inputnumber';
import { toNumberOrNull } from '../../js/filters-helpers';

// uses BootstrapVue textarea, but this is a custom Formulate input

export default {
    name: 'FormulateInteger',
    components: {
        PrimeInputNumber,
    },
    props: {
        context: {  // standard Formulate input context 
            type: Object,
            required: true
        },
        decimalPlaces: {
            type: Number,
            required: false,
        },
        min: {
            type: Number,
            default: null,
        },
        max: {
            type: Number,
            default: null,
        },
        step: {
            type: Number,
            default: 1,
        }
        // all other props, just pass them on in context.attributes, they'll get passed to PrimeVue input
    },
    data() {
        return {
            // SNIPPETS
            localValue: null,  // need this???
        }
    },
    computed: {
        localMinFractionDigits() {
            return this.decimalPlaces ?? undefined;  // may not need this...
        },
        localMaxFractionDigits() {
            return this.decimalPlaces ?? undefined;  // may not need this...
        },
        localLocale() {
            return null;  // null is default for prime-vue number -- uses browser value? you can set localMatcher prop
        },
        isDisabled() {
            return this.context.attributes?.disabled ?? false;
        },
        placeholder() {
            return this.context.placeholder ?? 'Enter number...';
        },
    },
    watch: {
        'context.model': {
            immediate: true,
            handler: function(newVal) {
                // parse to localValue here, then update context.model on @input 
                this.localValue = toNumberOrNull(newVal);
            },
        },
    },
    mounted() {
        
    },
    methods: {
        handleInput(value) {
            // completes our v-model - need to update context.model here, since we just have watcher on that to parse value correctly
            this.context.model = value;  // then watcher on context.model will set this.localValue
        },
    }
}
</script>

<style>

</style>